import { Dropdown, Layout } from "antd";
import { Header } from "antd/es/layout/layout";
import logo from "../assets/logo512.png";
import { ReactComponent as LanguageSvg } from "../assets/images/header/language.svg";
import { ReactComponent as ViVnSvg } from "../assets/images/header/vi_VN.svg";
import { ReactComponent as EnUsSvg } from "../assets/images/header/en_US.svg";
import { useDispatch, useSelector } from "react-redux";
import { usersAction } from "../store";
import { saveLocale } from "../hooks/useHttp";

const HeaderComponent = () => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.users.locale);
  
  const selectLocale = ({ key }) => {
    dispatch(usersAction.setLocale(key));
    saveLocale(key);
  };

  return (
    <Layout className="layout">
      <Header className="app-header">
        <div className="header-left" />
        
        {/* Center: Logo with glow effect */}
        <div className="header-center">
          <div className="header-logo-container">
            <img src={logo} className="header-logo" alt="logo" />
          </div>
        </div>
        
        <div className="header-right">
          <Dropdown
            menu={{
              onClick: (info) => selectLocale(info),
              items: [
                {
                  key: "vi_VN",
                  icon: <ViVnSvg />,
                  disabled: locale === "vi_VN",
                  label: "Tiếng việt",
                },
                {
                  key: "en_US",
                  icon: <EnUsSvg />,
                  disabled: locale === "en_US",
                  label: "English",
                },
              ],
            }}
          >
            <span>
              <LanguageSvg
                id="language-change"
                style={{
                  scale: "1.5",
                  marginBottom: 10,
                  translate: "0 0",
                  cursor: "pointer",
                  filter: "brightness(0) invert(1)"
                }}
              />
            </span>
          </Dropdown>
        </div>
      </Header>
    </Layout>
  );
};
export default HeaderComponent;
